/*
 * @Author: 吴紫阳 764401855@qq.com
 * @Date: 2022-09-20 10:41:32
 * @LastEditors: 吴紫阳 764401855@qq.com
 * @LastEditTime: 2022-09-30 16:37:14
 * @FilePath: \pit-bimwin-react-ui\src\components\PitModule\treeStore.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { uuid } from '../../utils/index.js';

let nodeIdSeed = 0;

export default class Node {
  map: any = {};
  data = null;
  props: any = null;
  index = false;
  indexData = [];
  defaultExpandAll = [];
  flattenedData = [];

  constructor(options: any) {
    this.data = options.data;
    this.props = options.props;
    this.defaultExpandAll = options.defaultExpandAll;
    this.map = {};
    this.setData(this.data);
    this.index = false;
    this.indexData = [];
    this.flattenedData = [];
  }

  setData(data: any) {
    this.data = data;
    this.transformData(this.data, 0);
    this.indexData = Object.values(this.map);
  }

  transformData(
    data: any,
    n: any,
    parent = null,
    parentName = null,
    parentIds: any = null
  ) {
    let level = n || 0;
    level++;
    if (data.length > 0) {
      data.forEach((item: any) => {
        item.parent = parent;
        item.parentName = parentName
          ? parentName + ' > ' + item[this.props.label]
          : item[this.props.label];
        if (!item.parentIds) {
          item.parentIds = [];
        }
        if (parent) item.parentIds = [...parentIds, parent];
        item.Id = item.Id || uuid();
        this.map[item.Id] = item;
        item.data = JSON.parse(JSON.stringify(item));
        item.id = nodeIdSeed++;
        item.checked = item[this.props.checked]
          ? item[this.props.checked]
          : true;
        item.expanded = item.expanded ? item.expanded : false;
        item.indeterminate =
          typeof item.indeterminate === 'undefined'
            ? false
            : item.indeterminate;
        item.isCheckbox = item[this.props.isCheckbox]
          ? item[this.props.isCheckbox]
          : false;
        item.visible = true;
        item.level = level;
        item.text = item[this.props.label];
        item.load = false;
        item.loadStatus = false;
        item.hasChildren = !!(
          item[this.props.children] && item[this.props.children].length > 0
        );

        if (typeof item[this.props.children] === 'undefined') {
          item[this.props.children] = [];
        }

        if (item[this.props.children] && item[this.props.children].length > 0) {
          this.transformData(
            item[this.props.children],
            level,
            item.Id,
            item.parentName || '',
            item.parentIds
          );
        }
      });
    }
  }
}
